export type New<T> = new(...args: any[]) => T;

export type New0<T> = new() => T;

export type New1<A1, T> = new(a1: A1) => T;

export type New2<A1, A2, T> = new(a1: A1, a2: A2) => T;

export type New3<A1, A2, A3, T> = new(a1: A1, a2: A2, a3: A3) => T;

export type Callback = () => void;

export type Predicate<T> = (t: T) => boolean;

export type Dict<K extends string | number, V> = {
    [index in K]?: V;
};

export type EnumDict<K extends string | number, V> = {
    [index in K]: V;
};

export type Mixin<T, M> = M | ((this: T & M) => M);

export function Mix<T, M1, M2, M3, M4, M5, M6, M7, M8>(t: (new(...args: any[]) => T), ...mixins: [
    (Mixin<T, M1>),
    (Mixin<T, M2>)?,
    (Mixin<T, M3>)?,
    (Mixin<T, M4>)?,
    (Mixin<T, M5>)?,
    (Mixin<T, M6>)?,
    (Mixin<T, M7>)?,
    (Mixin<T, M8>)?]
): New<T & M1 & M2 & M3 & M4 & M5 & M6 & M7 & M8> {

    class M extends (t as any) {
        constructor(...args: any[]) {
            super(...args);
            for (const m of mixins) {
                if (typeof m === "function") {
                    // @ts-ignore
                    m.call(this);
                }
            }
        }
    }

    for (const m of mixins) {
        if (!m) {
            throw new Error("Mixin is undefined");
        }
        for (const p of Object.getOwnPropertyNames(m)) {
            const d = Object.getOwnPropertyDescriptor(m, p)!;
            if (d.enumerable) {
                Object.defineProperty(M.prototype, p, d);
            }
        }
    }

    return M as any;
}

export function array<K extends number | string, V, T>(
    elementFactory: ((key: K, value?: V) => T),
    data?: number | { [P in K]: V })
    : T[] & { elementFactory: (key: K, value?: V) => T } {

    const ar: T[] & { elementFactory: (key: K, value?: V) => T } = [] as any;
    ar.elementFactory = elementFactory;
    if (typeof data === "number") {
        for (let i = 0; i < data; i++) {
            ar.push(elementFactory(i as K));
        }
    } else if (typeof data === "object") {
        for (const p of Object.getOwnPropertyNames(data)) {
            ar.push(elementFactory(p as K, (data as any)[p]));
        }
    }
    return ar;
}

export function dict<K extends string | number, V>(ar: K[], mapper: (k: K, i?: number) => V): Dict<K, V> {
    return ar.reduce((a, t, i) => {
        a[t] = mapper(t, i);
        return a;
    }, {} as Dict<K, V>);
}
